/**
 * Types for Order Change submission flow results
 */

/**
 * Status from the polling API (GET /OrderManagement/v2/Change/{orderId}/requests/{requestId})
 */
export type OrderChangeRequestStatusValue = 'pending' | 'completed' | 'failed'

/**
 * Transaction result type after polling completes.
 * Maps API status to meaningful result states.
 */
export type TransactionResultType =
  | 'success' // completed + !requiresManualApproval
  | 'pendingDispatch' // completed + requiresManualApproval
  | 'failure' // failed
  | 'pending' // polling timed out while still pending

/**
 * Result screen type to display after order change submission.
 * Simplified to two states for UI presentation.
 */
export type OrderChangeResultType =
  | 'success' // Order change was approved - show success screen
  | 'review' // Order change needs review (pendingDispatch, pending, failure) - show review screen

/**
 * Error modal variant for different error scenarios
 */
export type ErrorModalVariant =
  | 'retryable' // 500 errors - can retry
  | 'nonRetryable' // 400 errors - cannot retry
  | 'checksum' // 400 checksum conflict - need to refresh

/**
 * Error modal state for managing modal visibility and variant
 */
export interface ErrorModalState {
  isOpen: boolean
  variant: ErrorModalVariant | null
  message?: string
}

/**
 * Maps transaction result to result screen type
 */
export const mapTransactionResultToScreenType = (
  result: TransactionResultType
): OrderChangeResultType => {
  if (result === 'success') {
    return 'success'
  }
  // pendingDispatch, pending, failure all show review screen
  return 'review'
}
